<template>
  <!-- Begin Page Content -->
  <v-container>
    <v-row style="max-width: 1280px" class="mx-auto">
      <h4 class="text-primary font-weight-bold my-4">Даaлгаварууд</h4>
    </v-row>
    <v-row
      justify="start"
      style="max-width: 1280px"
      class="mx-auto"
      v-if="lessons != null && lessons.length > 0"
    >
      <v-col
        cols="12"
        md="4"
        lg="4"
        v-for="(lesson, index) in lessons"
        v-bind:key="lesson.id"
      >
        <v-card class="pa-4">
          <v-card-actions>
            <v-row class="d-flex justify-content-between">
              <span class="my-title">{{ index + 1 }}. {{ lesson.name }} </span>
              <div>
                <span class="badge badge-group" v-if="lesson.isGroup"
                  >группээр</span
                >
                <span class="badge badge-class" v-else>ангиар</span>
              </div>
            </v-row>
          </v-card-actions>

          <v-card-text class="pb-0">
            {{ getXTeacherNameFromLesson(lesson) }}
            <!-- <small
              v-if="lesson.teacherData && lesson.teacherData.onlineroom != null"
              @click="_goToTeacherOnlineRoom(lesson.teacherData)"
              class="badge badge-danger"
              style="cursor: pointer"
              >Online room
            </small> -->
          </v-card-text>
          <div v-if="lesson.topics">
            <v-divider class="mx-4"></v-divider>
            <template v-for="topic in lesson.topics">
              <template v-for="(content, cindex) in topic.contents">
                <div
                  tabindex="-1"
                  class="pa-0 v-list-item theme--light"
                  :key="cindex"
                  v-if="content.type == 'assignment'"
                  style="cursor: pointer"
                  @click="_goContent(lesson, topic, content)"
                >
                  <div
                    class="v-avatar v-list-item__avatar"
                    style="height: 40px; min-width: 40px; width: 40px"
                  >
                    <v-icon>mdi-clipboard-text-multiple-outline</v-icon>
                  </div>
                  <div class="v-list-item__content">
                    <div class="v-list-item__title body-2 font-weight-medium">
                      {{ content.name }}
                    </div>
                    <!-- <div class="v-list-item__subtitle">23 Dec 2020</div> -->
                  </div>
                  <div class="v-list-item__action">
                    <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <v-divider class="mx-4"></v-divider>
          <v-card-actions>
            <v-row justify="end">
              <!-- <v-btn
                v-if="lesson.onlineroom"
                depressed
                color="error"
                @click="_goOnlineRoom(lesson)"
                class="px-2"
              >
                Ангийн өрөө
              </v-btn>
              <span v-else></span> -->

              <!-- <v-btn color="primary" @click="_goDetail(lesson)"> Үзэx </v-btn> -->
              <button
                @click="_goDetail(lesson)"
                type="button"
                class="shadow-sm primary v-btn v-btn--has-bg v-size--small"
              >
                <span class="v-btn__content"
                  ><!---->
                  Үзэx
                </span>
              </button>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-container style="max-width: 1280px" class="mx-auto">
      <h4 class="text-primary font-weight-bold my-4">Сонгон суралцаx</h4>

      <div class="row" v-if="lessonGroups != null && lessonGroups.length > 0">
        <div
          class="col-md-4"
          v-for="(lessongroup, index) in lessonGroups"
          v-bind:key="lessongroup.id"
        >
          <div class="card mb-4 box-shadow mycard">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <span
                  style="color: black; font-weight: bold"
                  v-if="
                    lessongroup.lessonData != undefined &&
                    lessongroup.lessonData != null
                  "
                >
                  {{ index + 1 }}. {{ lessongroup.lessonData.name }}
                </span>

                <div>
                  <span
                    class="badge badge-group"
                    v-if="
                      lessongroup.lessonData != undefined &&
                      lessongroup.lessonData != null &&
                      lessongroup.lessonData.isGroup
                    "
                    >группээр</span
                  >
                  <span class="badge badge-class" v-else>ангиар</span>
                </div>
              </div>
              <p>
                <span
                  v-if="
                    lessongroup.teacherData &&
                    lessongroup.teacherData.lastName &&
                    lessongroup.teacherData.lastName.length > 0
                  "
                >
                  {{ lessongroup.teacherData.lastName[0] }}.</span
                >
                {{ lessongroup.teacherData.name }}
                <span
                  v-if="
                    lessongroup.lessonData != undefined &&
                    lessongroup.lessonData != null &&
                    lessongroup.teacherData.onlineroom != null
                  "
                  @click="_goToTeacherOnlineRoom(lessongroup.teacherData)"
                  class="badge badge-danger"
                  style="cursor: pointer"
                  >Online room
                </span>
              </p>
              <hr />
              <div class="d-flex justify-content-between">
                <button
                  class="btn btn-warning btn-sm py-0"
                  v-if="
                    lessongroup.lessonData != undefined &&
                    lessongroup.lessonData != null &&
                    lessongroup.lessonData.onlineroom
                  "
                  @click="_goOnlineRoom(lessongroup.lessonData)"
                >
                  Ангийн өрөө
                </button>

                <button
                  v-if="
                    lessongroup.lessonData != undefined &&
                    lessongroup.lessonData != null
                  "
                  class="btn btn-primary btn-sm py-0 text-center"
                  @click="_goDetail(lessongroup.lessonData)"
                >
                  Үзэx
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="loading == false" class="text-center alert alert-info">
        Мэдээлэл байxгүй байна!
      </div>
    </v-container>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </v-container>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
import myfunction from "./global/myfunction.js";
import axios from "axios";
export default {
  name: "LessonGrid",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending: {
        content: [],
      },
      school: null,
      loading: false,
      student: null,
      schoolId: null,
      lessonCategories: [],
      lessonGroups: [],
    };
  },
  mixins: [myfunction],
  created() {
    // fb.db 
    //   .collection("users")
    //   .doc(this.currentUser.uid)
    //   .update({
    //     bbbb: new Date(),
    //     bbbbbb: fb.firestore.FieldValue.serverTimestamp(),
    //   })
    //   .then(() => {
  
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
          this._getInitData();
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  methods: {
    _getCurrentServerTime() {
      //console.log(fb.serverTime)
      //return fb.firestore.FieldValue.serverTimestamp()
      //fb.realdb.ref('https://surguuli-91016.firebaseio.com/').set({name:'testtest'});
      //console.log(fb.realdb)
      //fb.database().ref('users/user1 ').set({testname:"TT"})
      //fb.firebase.database().ref('users/user1 ').set({testname:"TT22"})
      //  var offsetRef = fb.database().ref(".info/serverTimeOffset");
      //   offsetRef.on("value", (snap) => {
      //     var offset = snap.val();
      //     var estimatedServerTimeMs = new Date().getTime() + offset;
      //   });

      // var offsetRef = fb.realdb.ref("users");
      // offsetRef.on("value", (snap) => {
      //   console.log(snap.val());
      // });

      //console.log(fb.firestore.FieldValue.serverTimestamp())
      console.log(this.currentUser.uid);
      // const ref = fb.db.collection("users").doc(this.currentUser.uid).set({
      //     createdAt: fb.firestore.FieldValue.serverTimestamp(),
      //   })
      //   .then(() => {
      //     console.log("Done");
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });

      return "cc";
    },
    _isThisLessonForStudent(category) {
      if (this.student.lessonGroups) {
        for (var sg of this.student.lessonGroups) {
          for (var lesson of category.lessons) {
            for (var gr of lesson.lessonGroups) {
              if (gr.group.path == sg.path) return lesson;
            }
          }
        }
      }
      return false;
    },
    _isLessonAvailable(category) {
      //his.getXTeacherName(category.lessons[0]);
      if (category.lessons.length == 1) {
        var lesson = category.lessons[0];
        if (lesson && this.schoolId && lesson.id) {
          return lesson;
        }
      } else {
        if (this.student.lessonGroups) {
          for (var sg of this.student.lessonGroups) {
            for (var less of category.lessons) {
              if (less.lessonGroups) {
                for (var g of less.lessonGroups) {
                  if (sg.path == g.group.path) return less;
                }
              } else return null;
            }
          }
        }
        return null;
      }
    },
    _existOnlineRoom(category) {
      for (var lesson of category.lessons) {
        if (lesson.finalGrade == undefined) continue;
        else {
          if (lesson && lesson.school && lesson.id) {
            if (lesson.onlineroom) return true;
            else return false;
          }
        }
      }
      return false;
    },
    _hasThisTeacherOnlineRoom(category) {
      for (var lesson of category.lessons) {
        if (lesson.finalGrade == undefined) continue;
        else {
          if (
            lesson &&
            lesson.school &&
            lesson.id &&
            lesson.teacher != null &&
            lesson.teacher.onlineroom != null
          ) {
            return true;
          } else return false;
        }
      }
      return false;
    },
    async _goToTeacherOnlineRoom(teacher) {
      window.open(teacher.onlineroom, "_blank");
    },
    _goContent(lesson, topic, content) {
      this.$router.push({
        name: "StudentContentDetail",
        params: {
          schoolId: lesson.school.id,
          lessonId: lesson.id,
          topicId: topic.id,
          contentId: content.id,
          showContainer: true,
        },
      });
    },
    _goDetail(lesson) {
      this.$router.push({
        name: "ShareLessonToPublicforStudent",
        params: { lessonId: lesson.id, schoolId: this.schoolId, sts: false },
      });
    },
    _registerAccess(lesson) {
      var currentTime = null;
      axios
        .get("https://worldtimeapi.org/api/timezone/Asia/Ulaanbaatar")
        .then((response) => {
          currentTime = new Date(Date.parse(response.data.datetime));
          let clientip = response.data.client_ip;
          lesson.ref
            .collection("onlineroomlogs")
            .doc(this.student.id)
            .collection("onlineroomlogs")
            .doc()
            .set({
              student: this.student.id,
              studentRef: this.student.ref,
              accessedDate: currentTime,
              clientip: clientip,
              dayOfYear: response.data.day_of_year,
              weekNumber: response.data.week_number,
              dayNumber: response.data.day_of_week,
            });
        });
      // console.log(customerData.ref);
      // console.log(customerData.departmentData, customerData.programData,customerData.programData.onlineroom)
    },
    _goOnlineRoom(lesson) {
      window.open(lesson.onlineroom, "_blank");
    },
    _getTeachers(category) {
      //his.getXTeacherName(category.lessons[0]);
      if (category.lessons.length == 1) {
        var lesson = category.lessons[0];
        if (lesson && this.schoolId && lesson.id) {
          return this.getXTeacherName(category.lessons[0]);
        }
      } else {
        if (this.student.lessonGroups) {
          for (var sg of this.student.lessonGroups) {
            for (var less of category.lessons) {
              if (less.lessonGroups) {
                for (var g of less.lessonGroups) {
                  if (sg.path == g.group.path)
                    return this.getXTeacherName(less);
                }
              } else return "****************************************";
            }
          }
        }
      }
    },
    _sortedEndCategoryDataArray: function () {
      function compare(a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 1;
        return 0;
      }
      return this.lessonCategories.sort(compare);
    },
    async _checkCategory(categoryDoc, lesson) {
      var foundData = null;
      for (var i = 0; i < this.lessonCategories.length; i++) {
        var data = this.lessonCategories[i];
        if (data.id == categoryDoc.id) {
          foundData = data;
          break;
        }
      }
      if (foundData == null) {
        let foundData = categoryDoc.data();
        foundData.id = categoryDoc.id;
        foundData.lessons = [];
        foundData.lessons.push(lesson);
        this.lessonCategories.push(foundData);
      } else {
        foundData.lessons.push(lesson);
      }
      return foundData;
    },
    async _findCategory(schoolId, lesson) {
      var catRef = await fb.db
        .collection("schools/" + schoolId + "/categories")
        .doc(lesson.category.id)
        .get();
      if (catRef.exists) {
        lesson.categoryTypeId = catRef.data().typeDetail.id;
        lesson.categoryTypeName = catRef.data().typeDetail.name;
        lesson.categoryData = catRef.data();
        lesson.categoryId = catRef.id;
        this._checkCategory(catRef, lesson);
        this._sortedEndCategoryDataArray();
        for (var i = 0; i < this.lessonCategories.length; i++) {
          var cat = this.lessonCategories[i];
          if (this._isLessonAvailable(cat) == null) {
            this.lessonCategories.splice(i, 1); //TODOO
          }
        }
      }
    },
    _isLessonGroupAllowed(lesson) {
      if (this.student.lessonGroups) {
        for (var slg of this.student.lessonGroups) {
          for (var lg of lesson.lessonGroups) {
            if (lg.group.path == slg.path) return true;
          }
        }
      }
      return false;
    },
    async _getLessons(programId) {
      this.lessons = [];
      await fb.db
        .collection("/schools/" + this.schoolId + "/lessons")
        .where("programIds", "array-contains", programId)
        .get()
        .then((lessonDocs) => {
          lessonDocs.forEach(async (lessonDoc) => {
            let lesson = lessonDoc.data();
            lesson.id = lessonDoc.id;
            lesson.ref = lessonDoc.ref;
            // var parentLes = await lesson.category.get();
            // lesson.bgColor = parentLes.data().bgColor;
            // lesson.foreColor = parentLes.data().foreColor;
            var catRef = await fb.db
              .collection("schools/" + this.schoolId + "/categories")
              .doc(lesson.category.id)
              .get();
            if (catRef.exists) {
              lesson.categoryTypeId = catRef.data().typeDetail.id;
              lesson.categoryTypeName = catRef.data().typeDetail.name;
              lesson.categoryData = catRef.data();
              lesson.categoryId = catRef.id;
            }

            var teacherDoc = await lesson.teacher.get();
            if (teacherDoc.exists) {
              lesson.teacherData = teacherDoc.data();
              lesson.teacherData.id = teacherDoc.id;
            }

            if (lesson.categoryTypeId == "zaaval" && !lesson.isGroup) {
              if (lesson.isGroup && this._isLessonGroupAllowed(lesson))
                this._addLesson(lesson);
              else this._addLesson(lesson);
            }
          });
        });
    },
    _addLesson(lesson) {
      if (
        !(
          lesson.deleted != null &&
          lesson.deleted != undefined &&
          lesson.deleted == true
        )
      ) {
        fb.db
          .collection(lesson.ref.path + "/topics")
          .get()
          .then((doc) => {
            lesson.topics = [];
            doc.forEach((topic) => {
              let topi = topic.data();
              topi.ref = topic.ref;
              topi.id = topic.id;

              fb.db
                .collection(topi.ref.path + "/details")
                .get()
                .then((xdoc) => {
                  topi.contents = [];
                  lesson.contents = [];
                  xdoc.forEach((content) => {
                    let cont = content.data();
                    cont.ref = content.ref;
                    cont.id = content.id;
                    //if(cont.type='assignment')
                    topi.contents.push(cont);
                  });
                });
              lesson.topics.push(topi);
            });
          });

        this.lessons.push(lesson);
      }
    },
    async _getInitData() {
      var userDoc = await fb.usersCollection.doc(this.currentUser.uid).get();
      if (
        userDoc.exists &&
        userDoc.data().role != null &&
        userDoc.data().role == "student" &&
        userDoc.data().customer != null
      ) {
        var studentDoc = await userDoc.data().customer.get();
        if (studentDoc.exists) {
          this.school = studentDoc.data().school;
          this.schoolId = this.school.id;
          this.student = studentDoc.data();
          this.student.id = studentDoc.id;
          this.student.ref = studentDoc.ref;
        }
      }
      this.loading = true;
      await this._getLessons(this.student.program.id);
      // console.log(this.lessons.length)
      if (this.student.lessonGroups) {
        for (var grp of this.student.lessonGroups) {
          await this._getLessonOfGroup(grp);
          //this.lessonGroups.push(grp.path);
        }
      }

      this.loading = false;
    },

    async _getLessonOfGroup(group) {
      var groupDoc = await fb.db.doc(group.path).get();
      if (groupDoc.exists) {
        let grp = groupDoc.data();
        grp.id = groupDoc.id;
        grp.ref = groupDoc.ref;

        if (grp.lesson) {
          var lessonDoc = await grp.lesson.get();
          if (lessonDoc.exists) {
            grp.lessonData = lessonDoc.data();
            grp.lessonData.id = lessonDoc.id;
          }
        }
        if (grp.teacher) {
          var teacherDoc = await grp.teacher.get();
          if (teacherDoc.exists) {
            grp.teacherData = teacherDoc.data();
            grp.teacherData.id = teacherDoc.id;
          }
        }
        // // console.log(grp.teacherData);

        if (grp.lessonData != null && grp.lessonData != undefined) {
          var catRef = await grp.lessonData.category.get();
          if (catRef.exists) {
            grp.lessonData.categoryTypeId = catRef.data().typeDetail.id;
            grp.lessonData.categoryTypeName = catRef.data().typeDetail.name;
            grp.lessonData.categoryData = catRef.data();
            grp.lessonData.categoryId = catRef.id;
          }
          if (grp.lessonData.categoryTypeId == "zaaval") {
            this.lessons.push(grp.lessonData);
          }
          //console.log(grp)
          else this.lessonGroups.push(grp);
        }
        // return grp;
      }
    },
    _isNotLessonExists(lesson) {
      for (var less of this.lessons) {
        console.log(lesson.id);
      }
      return true;
    },
    _getColor(lesson) {
      var colorText = "";
      if (lesson.bgColor == undefined) {
        colorText = colorText + "background-color:#fff;";
      } else {
        colorText = colorText + "background-color:" + lesson.bgColor;
      }
      return colorText;
    },
    _getTextColor(lesson) {
      var colorText = "";

      if (lesson.foreColor == undefined) {
        colorText = colorText + "color:#4e73df;";
      } else {
        colorText = colorText + "color:" + lesson.foreColor;
      }
      return colorText;
    },
  },
};
</script>
<style>
.card-img-top {
  object-fit: cover !important;
  /* max-height: 165px!important; */
}
.v-list-item__title {
  -ms-flex-item-align: center;
  align-self: center;
  font-size: 0.8rem !important;
}
</style>